/* global apiConn */
const React = require('react');

const eventHandler = require('./eventhandler.js');

const FilterDropDown = React.createClass({

  propTypes: {
    id: React.PropTypes.string,
    items: React.PropTypes.array,
    selected: React.PropTypes.string,
    onChange: React.PropTypes.func
  },

  getInitialState () {
    return {};
  },

  itemChange (item) {
    if (this.props.onChange) {
      this.props.onChange({id: this.props.id, value: item.target.value});
    }
  },

  render () {
    const id = this.props.id;
    const items = this.props.items;
    const selected = this.props.selected;

    const options = [];

    for (let i = 0; i < items.length; i++) {
      let key = id + '_' + i;
      options.push(<option key={key} value={items[i].value}>{items[i].title}</option>);
    }

    return (
      <div className='u-margin-b-m'>
        <label htmlFor={id} className='label' id='{id}_holder'>
          <div className='dropdown'>
            <div className='triangle-down dropdown-triangle-down'></div>
            <select className={`dropdown-select filter-${id}`} ref='select' id={id} defaultValue={selected} onChange={this.itemChange}>
              {options}
            </select>
          </div>
          <span className='select-box__arrows'></span>
        </label>
      </div>
    );
  }
});

const Filter = React.createClass({
  propTypes: {
    category: React.PropTypes.string,
    filter: React.PropTypes.object
  },

  getInitialState () {
    const categoryItems = [];
    categoryItems.push({value: 'alla', title: 'Alla'});
    categoryItems.push({value: 'artiklar', title: 'Artiklar'});
    categoryItems.push({value: 'recept', title: 'Recept'});
    categoryItems.push({value: 'profiler', title: 'Profiler'});

    let selectedCategory = 'alla';
    if (this.props.category) {
      selectedCategory = this.props.category;
    }

    let out = null;

    if (this.props.filter) {
      out = this.props.filter;
    } else {
      out = {};
    }

    out.dataLoaded = false;
    out.categoryItems = categoryItems;
    out.selectedCategory = selectedCategory;

    return out;
  },

  componentDidMount () {
    this.loadData(function (err, res) {
      if (err) {
        console.log('Load data error', err);
      } else {
        res.dataLoaded = true;
        this.setState(res);
      }
    }.bind(this));

    if (this.props.mainFilter) {
      eventHandler.on('filterChange', this.runFilter);
    }
    eventHandler.on('clearFilters', this.clearFilters);

  },

  componentWillUnmount: function () {
    if (this.props.mainFilter) {
      eventHandler.removeListener('filterChange', this.runFilter);
    }
    eventHandler.removeListener('clearFilters', this.clearFilters);
  },

  getItemTitle (items, value) {
    const item =  items.find(function (item) {
      return item.value === value
    })

    return item ? item.title : ''
  },

  categoryChange (item) {
    const title = this.getItemTitle(this.state.categoryItems, item.value)
    eventHandler.emit('filterSelectChange', {...item, title});

    this.setState({selectedCategory: item.value}, function () {
      this.runFilter();
    }.bind(this));
  },

  filterChange (item, items) {
    const title = this.getItemTitle(items, item.value)
    eventHandler.emit('filterSelectChange', {...item, title});

    this.runFilter();
  },

  getProfileFilter () {
    const profiles = this.state['profiles'];

    const profileFilter = {};
    profileFilter.id = 'skribent';
    if (this.state.skribent) {
      profileFilter.selected = this.state.skribent;
    } else {
      profileFilter.selected = '';
    }

    profileFilter.items = [];

    profileFilter.items.push({
      value: 'alla',
      title: 'Skribent'
    });

    for (let i = 0; i < profiles.length; i++) {
      let profile = profiles[i];

      profileFilter.items.push({
        value: profile['slug'],
        title: profile['name']
      });
    }
    return profileFilter;
  },

  getRecentFilters () {
    const filters = [];

    // PROFILE
    const profileFilter = this.getProfileFilter();
    filters.push(profileFilter);

    // Type
    const typeFilter = {};
    typeFilter.id = 'typ';
    if (this.state.typ) {
      typeFilter.selected = this.state.typ;
    } else {
      typeFilter.selected = '';
    }

    typeFilter.items = [];

    typeFilter.items.push({
      value: 'alla',
      title: 'Typ av artikel'
    });

    typeFilter.items.push({
      value: 'artikel',
      title: 'Artikel'
    });

    typeFilter.items.push({
      value: 'recension',
      title: 'Recension'
    });

    filters.push(typeFilter);

    return filters;
  },

  getAllFilters () {
    const filters = [];

    // PROFILE
    const profileFilter = this.getProfileFilter();
    filters.push(profileFilter);

    return filters;
  },

  getRecipeFilters () {
    const filters = [];

    const types = this.state['recipe-types'];

    // TYPE
    const typeFilter = {};
    typeFilter.id = 'typ';

    if (this.state.typ) {
      typeFilter.selected = this.state.typ;
    } else {
      typeFilter.selected = '';
    }

    typeFilter.items = [];

    typeFilter.items.push({
      value: 'alla',
      title: 'Typ'
    });

    for (let i = 0; i < types.length; i++) {
      let type = types[i];

      typeFilter.items.push({
        value: type['slug'],
        title: type['name']
      });
    }

    filters.push(typeFilter);

    // PROFILE
    const profileFilter = this.getProfileFilter();
    filters.push(profileFilter);

    // cooktime
    const cookTimeFilter = {};
    cookTimeFilter.id = 'tid';
    if (this.state.tid) {
      cookTimeFilter.selected = this.state.tid;
    } else {
      cookTimeFilter.selected = '';
    }

    cookTimeFilter.items = [];

    cookTimeFilter.items.push({
      value: 'alla',
      title: 'Tid'
    });

    var cooktime = 0;
    var cooktime_str = '';

    var increment = 30;
    for (let i = 0; i <= 90; i += 30) {

      if (i < increment) {
        cooktime = '0_' + increment;
        cooktime_str = 'Under ' + increment + ' minuter';
      } else if (i < 90) {
        cooktime = i + '_' + (i + increment);
        cooktime_str = 'Mellan ' + i + ' och ' + (i + increment) + ' minuter';
      } else {
        cooktime = '90_x';
        cooktime_str = 'Över 90 minuter';
      }

      cookTimeFilter.items.push({
        value: cooktime,
        title: cooktime_str
      });
    }

    /*
    for (let i = 9, increment = 1; i <= 90; i += increment) {
      increment = (i < 10 ? 1 : i < 30 ? 5 : 10);

      if (i < 10) {
        cooktime = '0_' + (i + 1);
        cooktime_str = 'under ' + (i + 1) + ' minuter';
      } else if (i < 90) {
        cooktime = i + '_' + (i + increment);
        cooktime_str = 'mellan ' + i + ' och ' + (i + increment) + ' minuter';
      } else {
        cooktime = '90_x';
        cooktime_str = 'över 90 minuter';
      }

      cookTimeFilter.items.push({
        value: cooktime,
        title: cooktime_str
      });
    }*/

    filters.push(cookTimeFilter);

    return filters;
  },

  loadData (cb) {
    let done = 0;
    let todo = 4;

    let out = {};

    const loadDone = function () {
      done += 1;
      if (done >= todo) {
        cb(null, out);
      }
    };

    apiConn.doCall('entryhandler', 'getRecipeTypes', {}, (status, data) => {
      out['recipe-types'] = data;
      loadDone();
    });

    apiConn.doCall('profilehandler', 'getActiveProfiles', {}, (status, data) => {
      out['profiles'] = data;
      loadDone();
    });

    apiConn.doCall('producthandler', 'getTypes', {}, (status, data) => {
      out['product-types'] = data;
      loadDone();
    });

    apiConn.doCall('producthandler', 'getCountries', {}, (status, data) => {
      out['countries'] = data;
      loadDone();
    });
  },

  clearFilters () {
    this.refs.skribent.refs.select.value = 'alla'
    this.refs.typ.refs.select.value = 'alla'
    this.refs.tid.refs.select.value = 'alla'
  },

  runFilter () {
    const filter = {};

    const category = this.refs.vad.refs.select.value;

    filter.vad = category;

    switch (category) {
      case 'alla':
        filter.skribent = this.refs.skribent.refs.select.value;
        break;
      case 'artiklar':
        filter.typ = this.refs.typ.refs.select.value;
        filter.skribent = this.refs.skribent.refs.select.value;
        break;
      case 'recept':
        filter.typ = this.refs.typ.refs.select.value;
        filter.skribent = this.refs.skribent.refs.select.value;
        filter.tid = this.refs.tid.refs.select.value;
        break;
    }

    eventHandler.emit('filter', filter);
  },

  filterClick (e) {
    e.preventDefault();
    this.runFilter();
  },

  render () {
    let dropDowns = [];

    if (this.state.dataLoaded) {
      let filters = null;

      switch (this.state.selectedCategory) {
        case 'artiklar':
          filters = this.getRecentFilters();
          break;
        case 'recept':
          filters = this.getRecipeFilters();
          break;
        case 'alla':
          filters = this.getAllFilters();
          break;
        default:
            // no filters
          break;
      }

      for (let i = 0; filters && i < filters.length; i++) {
        let filter = filters[i];

        let key = 'filter_' + this.state.selectedCategory + '_' + i;
        dropDowns.push(<FilterDropDown key={key} ref={filter.id} id={filter.id} items={filter.items} selected={filter.selected} onChange={(item) => this.filterChange(item, filter.items)} />);
      }
    }

    return (
      <div className='card u-padding-a-s' id='sitesearch-browse-holder'>
        <form id='sitesearch_browse_form' method='GET' action='/recept'>
          <h3 className='label'>Kategori:</h3>

          <FilterDropDown ref='vad' id='vad' items={this.state.categoryItems} selected={this.state.selectedCategory} onChange={this.categoryChange} />

          <div id='sitesearch_options' className='u-margin-b-n'>
            {dropDowns}
          </div>
        </form>
      </div>
    );
  }
});

module.exports = Filter;



// WEBPACK FOOTER //
// ./src/scripts/components/filter.js